import React from 'react';
import styled from 'styled-components';
import Theme from '../../shared/theme';

const inlineMessageColor = {
  error: Theme.colors['error-color'],
  warning: Theme.colors['warning-color'],
  info: Theme.colors['instruction-color'],
  success: Theme.colors['success-color']
};

const InlineMessageStyle = styled('div')`
  font-size: 11px;
  color: ${({ level }) => inlineMessageColor[level]};
  padding: 0 2px;
  position: ${({ position }) => position};
`;

const InlineMessage = ({ level, position, children }) => (
  <InlineMessageStyle position={position} level={level}>
    {children}
  </InlineMessageStyle>
);

InlineMessage.defaultProps = {
  level: 'error',
  position: 'absolute'
};

export default InlineMessage;
